import { render, staticRenderFns } from "./admin-drawer.component.vue?vue&type=template&id=1e8a7ba1&scoped=true"
import script from "./admin-drawer.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-drawer.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admin-drawer.component.vue?vue&type=style&index=0&id=1e8a7ba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a7ba1",
  null
  
)

export default component.exports